module.exports = __webpack_public_path__ + "images/icons/flags/CA-170b64c3.svg";